import Api from '@/data/Api.ts';
import StringUtils from '@/infrastructure/support/utils/StringUtils.ts';

const API_URL_GET_ME = '/users/me';
const API_URL_UPDATE_ACCOUNT = '/users/me';
const API_URL_REGISTER_USER = '/companies/{0}/users';
const API_URL_GET_ALL_USERS_OF_COMPANY = '/companies/{0}/users';

export default class UserApi extends Api {
  /**
   * @param companyId The company to get the users from.
   * @param params The parameters to send with the request.
   * @param includes An array of relations to include with the entity e.g. ['company'].
   * @returns {Promise} A promise containing the response, or a thrown error.
   */
  getAllUsersOfCompany(
    companyId: number,
    params: {} = {},
    includes: string[] = [],
  ): Promise<any> {
    const url: string = StringUtils.stringFormat(
      API_URL_GET_ALL_USERS_OF_COMPANY,
      [companyId],
    );
    return this.standardGet(url, params, includes);
  }

  /**
   * @param companyId The company to get the users from.
   * @param payload The payload to send with the request.
   */
  registerUser(companyId: number, payload: {} = {}): Promise<any> {
    const url: string = StringUtils.stringFormat(API_URL_REGISTER_USER, [
      companyId,
    ]);
    return this.standardPost(url, payload);
  }

  /**
   * @param params The parameters to send with the request.
   * @param includes An array of relations to include with the entity e.g. ['company'].
   */
  getMe(params: {} = {}, includes: string[] = []): Promise<any> {
    return this.standardGet(API_URL_GET_ME, params, includes);
  }

  /** @param params The parameters to send with the request.*/
  update(params: {} = {}): Promise<any> {
    return this.standardPut(API_URL_UPDATE_ACCOUNT, params);
  }
}
